import { render, staticRenderFns } from "./Dependents.vue?vue&type=template&id=58025809&lang=pug&"
import script from "./Dependents.vue?vue&type=script&lang=js&"
export * from "./Dependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports